import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/auth/login.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/dashboard/dashboard.vue'),
    meta: {
      auth: true
    }
  },
	{	
		path: '/settings',
		component: () => import('../views/settings/index.vue'),
		meta: {
			auth: true,
		},
		children: [
			{
				path: '',
				name: 'Settings',
				component: () => import('../views/settings/company.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'branch',
				name: 'Branches',
				component: () => import('../views/settings/branches.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'payment',
				name: 'Payment',
				component: () => import('../views/settings/payment.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'users',
				name: 'Users',
				component: () => import('../views/settings/users.vue'),
				meta: {
					auth: true
				}
			}
		]
	},
	{
		path: '/absensi',
		component: () => import('../views/absensi/index.vue'),
		meta: {
			auth: true
		},
		children: [
			{
				path: '',
				name: 'Attendance',
				component: () => import('../views/absensi/absensi.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'report',
				name: 'Report',
				component: () => import('../views/absensi/laporan.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'employee',
				name: "Employee",
				component: () => import('../views/absensi/employee.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'employee/add-employee',
				name: 'Add Employee',
				component: () => import('../views/absensi/addEmployee.vue'),
				meta: {
					auth: true
				}
			},
			{
				path: 'employee/info-employee/:id',
				component: () => import('../views/absensi/employeeDetail.vue'),
				meta: {
					auth: true
				},
				children: [
					{
						path: '',
						name: 'Info Employyee',
						component: () => import('../views/absensi/personalData.vue'),
						meta: {
							auth: true
						}
					},
					{
						path: 'employement-data',
						name: 'Employement Data',
						component: () => import('../views/absensi/employeementData.vue'),
						meta: {
							auth: true
						}
					},
					{
						path: 'employee-attlog',
						name: 'Employee Attlog',
						component: () => import('../views/absensi/employeeAttlog.vue'),
						meta: {
							auth: true
						}
					},
					{
						path:'fingerprint',
						name: 'Fingerprint',
						component: () => import('../views/absensi/fingerprint.vue'),
						meta: {
							auth: true
						}
					}
				]
			}
		]
	},
	{
		path: '/products',
		component: () => import('../views/products/index.vue'),
		meta: {
			auth: true
		},
		children: [
			{
				path: '',
				name: 'Products',
				component: () => import('../views/products/items.vue'),
				meta: {
					auth: true
				},
			},
			{
				path: 'detail/:id',
				name: 'Detail Product',
				component: () => import('../views/products/detail.vue'),
				meta: {
					auth: true
				}
			}
		]
	},
	{
		path: '/ingredients',
		component: () => import('../views/ingredients/index.vue'),
		meta: {
			auth: true
		},
		children: [
			{
				path: '',
				name: 'Ingredients',
				component: () =>  import('../views/ingredients/ingredients.vue'),
				meta: {
					auth: true
				}
			}
		]	
	},
	{
		path: '/receipes',
		component: () => import('../views/receipes/index.vue'),
		meta: {
			auth: true
		},
		children: [
			{
				path: '',
				name: 'Receipes',
				component: () => import('../views/receipes/receipes.vue'),
				meta: {
					auth: true
				}
			}
		]
	},
	{
		path: '/summary-ingredients',
		name: 'Summary Ingredients',
		component: () => import('../views/summary/ingredients'),
		meta: {
			auth: true
		}
	},
	{
		path: '/summary-items',
		name: 'Summary Items',
		component: () => import('../views/summary/items'),
		meta: {
			auth: true
		}
	},
	{
		path: '/suppliers',
		name: 'Suppliers',
		component: () => import('../views/suppliers/index.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/purchasing',
		component: () => import('../views/purchasing/index.vue'),
		meta: {
			auth: true
		},
		children: [
			{
				path: '',
				name: 'Purchasing',
				component: () => import('../views/purchasing/purchasing.vue'),
				meta: {
					auth: true
				}
			}
		]
	},
	{
		path: '/transfer',
		name: 'Transfer',
		component: () => import('../views/transfer/transfer.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/adjustment',
		name: 'Adjustment',
		component: () => import('../views/adjustment/adjustment.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/sales',
		name: 'Penjualan',
		component: () => import('../views/sales/sales.vue'),
		meta: {
			auth: true
		}
	},
	
	{
		path: '/my-account',
		component: () => import('../views/auth/myaccount.vue'),
		name: 'My Account',
		meta: {
			auth: true
		}
	},
	{
		path: '/login',
		component: Login,
		name: 'Login'
	},
	{
		path: '/lost-password',
		component: () => import('../views/auth/lostpassword.vue')
	},
	{
		path: '/resetPassword/:token',
		component: () => import('../views/auth/reset.vue')
	},
]

const router = new VueRouter({
	scrollBehavior () {
		return {x: 0, y: 0, behavior: 'smooth'}
	},
	linkActiveClass: 'active',
	linkExactActiveClass: 'active',
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const tokenLocalStorage = localStorage.getItem('token')
	const userId = localStorage.getItem('userId')
	if(to.meta.auth && !store.getters['auth/token'] || to.meta.auth && !tokenLocalStorage || to.meta.auth && !userId) next({name: 'Login'})
	else if(!to.meta.auth && store.getters['auth/token'] && tokenLocalStorage && userId) next({name: 'Dashboard'})
	else next()
})

export default router
